function getExtension(file: File | Blob): string {
  if (file instanceof File) {
    const fileName = file.name;
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex !== -1) {
      return fileName.substring(dotIndex + 1).toLowerCase();
    }
    return "wav";
  } else {
    const mimeType = file.type;
    const mimeMap: Record<string, string> = {
      "audio/wav": "wav",
      "audio/x-wav": "wav",
      "audio/mpeg": "mp3",
      "audio/ogg": "ogg",
      "audio/aac": "aac",
      "audio/mp4": "m4a",
    };
    return mimeMap[mimeType] || "wav";
  }
}

export default getExtension;
